import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type IndiaZone = {
    countryId: Uuid;
    id: Uuid;
    name: string;
};

export const indiaZoneValidator: zod.ZodType<IndiaZone> = zod.strictObject({
    countryId: uuidZodValidator,
    id: uuidZodValidator,
    name: zod.string(),
});
